import { render, staticRenderFns } from "./PollDraftHandler.vue?vue&type=template&id=6bdc379b&scoped=true"
import script from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PollDraftHandler.vue?vue&type=style&index=0&id=6bdc379b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc379b",
  null
  
)

export default component.exports